interface StreakDisplayProps {
  streak: number;
  bestStreak: number;
  dailyStreak?: number;
  bestDailyStreak?: number;
  streakFreezeAvailable?: boolean;
}

const DAILY_MILESTONES = [7, 30, 100];

function getFlameSize(dailyStreak: number): string {
  if (dailyStreak >= 100) return "text-3xl";
  if (dailyStreak >= 30) return "text-2xl";
  if (dailyStreak >= 7) return "text-xl";
  return "text-lg";
}

export function StreakDisplay({
  streak,
  bestStreak,
  dailyStreak,
  bestDailyStreak,
  streakFreezeAvailable,
}: StreakDisplayProps) {
  const hasDailyStreak = dailyStreak !== undefined;
  const dailyActive = (dailyStreak ?? 0) > 0;
  const hotActive = streak > 0;
  const nextMilestone = DAILY_MILESTONES.find((m) => m > (dailyStreak ?? 0));

  return (
    <div className="flex flex-col gap-2">
      {hasDailyStreak && (
        <div className="flex items-center gap-3">
          <div className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-bold
            ${dailyActive ? "bg-orange-100 text-orange-600" : "bg-gray-100 text-gray-500"}`}
          >
            <span className={`${getFlameSize(dailyStreak ?? 0)} ${dailyActive ? "animate-pulse" : ""}`}>
              {dailyActive ? "\uD83D\uDD25" : "\uD83D\uDCA4"}
            </span>
            <span>{dailyStreak} day{dailyStreak !== 1 ? "s" : ""}</span>
          </div>
          <div className="flex flex-col text-xs text-gray-400">
            <span>Best: {bestDailyStreak ?? 0}</span>
            {nextMilestone && dailyActive && (
              <span>{nextMilestone - (dailyStreak ?? 0)} to {nextMilestone}-day milestone</span>
            )}
          </div>
          {streakFreezeAvailable && (
            <span className="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-600" title="Streak freeze available">
              {"\u2744\uFE0F"} Freeze ready
            </span>
          )}
        </div>
      )}
      <div className="flex items-center gap-3">
        <div className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-bold
          ${hotActive ? "bg-red-100 text-red-600" : "bg-gray-100 text-gray-500"}`}
        >
          <span className="text-lg">{hotActive ? "\uD83C\uDFAF" : "\u2014"}</span>
          <span>{streak} correct</span>
        </div>
        <span className="text-xs text-gray-400">Best: {bestStreak}</span>
      </div>
    </div>
  );
}
